import { Music24Locale, music24LocaleOf } from 'fym-shared/src/music24/music24Locales';

/**
 * The query parameter of the public SmartLink page that names its language. sml-preview reads it
 * (`sml-preview/app/src/i18n/pageLocale.ts`, `PAGE_LANG_PARAM`) before the browser language.
 */
export const PREVIEW_LANG_PARAM = 'lang';

/**
 * The address of a SmartLink page that the app shows or opens for the artist, in the app language.
 * Use it only for a preview (a frame, an "Open page" button). An address that the artist copies or
 * shares stays clean, so a fan gets the language of the browser. A locale that Music24 does not
 * have, or an address that does not parse, gives the address unchanged.
 */
export function withPreviewLang(address: string, appLocale: string | null | undefined): string {
  const locale: Music24Locale | null = music24LocaleOf(appLocale);
  if (locale === null || address === '') {
    return address;
  }
  try {
    const url = new URL(address);
    url.searchParams.set(PREVIEW_LANG_PARAM, locale);
    return url.toString();
  } catch {
    return address;
  }
}
